import { FormattedMessage } from 'react-intl';
import Snackbar from '@mui/material/Snackbar';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import type { RenderProgress } from './partsPolicy';

/**
 * Progress for a documentation rendered in parts. A whole project runs to
 * thousands of sheets and a couple of minutes — long enough that a spinner on
 * the row action alone reads as "frozen".
 *
 * Only shown for the part-wise path: a small export finishes before this could
 * paint, so `progress` stays null there.
 */
export default function PdfExportProgress({
    progress
}: {
    progress: RenderProgress | null;
}) {
    if (!progress) {
        return null;
    }
    const percent = Math.round((progress.done / progress.total) * 100);
    return (
        <Snackbar
            open
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
            <Paper elevation={6} sx={{ p: 2, minWidth: 320 }}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                    <FormattedMessage
                        id="findingPdf.progress"
                        values={{
                            done: progress.done,
                            total: progress.total
                        }}
                    />
                </Typography>
                <LinearProgress variant="determinate" value={percent} />
                <Box
                    sx={{
                        mt: 0.5,
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}
                >
                    <Typography variant="caption" color="text.secondary">
                        <FormattedMessage
                            id="findingPdf.progress.part"
                            values={{
                                part: progress.part,
                                parts: progress.parts
                            }}
                        />
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        {percent}%
                    </Typography>
                </Box>
            </Paper>
        </Snackbar>
    );
}
